import store from "@/store";

import core from "./methods/core";
import tracks from "./methods/tracks";
import albums from "./methods/albums";
import personal from "./methods/personal";
import artists from "./methods/artists";
import genres from "./methods/genres";
import directions from "./methods/directions";
import playlists from "./methods/playlists";
import pages from "./methods/pages";

export default {
  ...core(store),
  ...tracks(store),
  ...albums(store),
  ...personal(store),
  ...artists(store),
  ...genres(store),
  ...directions(store),
  ...playlists(store),
  ...pages(store)
};
